<script>
  import {onMount, setContext} from "svelte";
  import {writable} from "svelte/store";
  import {to, API} from "@API";
  import otoFamilyWhite from "@assets/oto_family.png";
  import otoFamilyGray from "@assets/oto_family_gray.png";
  import otoClinicBlack from "@assets/FertilityClinic_Lockup_Black.png";
  import otoClinicLight from "@assets/FertilityClinic_Lockup_Light.png";
  import otoTacticalBlack from "@assets/Tactical_Lockup_black.png";
  import otoTacticalLight from "@assets/Tactical_Lockup_light.png";
  import otoGymBlack from "@assets/Athlete_Lockup_black.png";
  import otoGymLight from "@assets/Athlete_Lockup_light.png";
  import tinycolor from "tinycolor2";
  import Tailwind from "../TailwindStyles.svelte";
  import MediaQuery from "@components/MediaQuery.svelte";
  import CustomerInformation from "@components/CustomerInformation.svelte"
  import posthog from 'posthog-js';
  import ProductInfo from "@components/ProductInfo.svelte"
  import ChoosePricing from "./b2b/ChoosePricing.svelte";
  import ChooseProduct from "./tfc/ChooseProduct.svelte";
  import {forcesLocalPickup} from '@utils/fulfillment.js';

  window.posthog = posthog;
  posthog.init('phc_spDRH8UjZ9rYb1LQcgY8TUYAki6cEtvK6WoCBFZIb3V', { api_host: 'https://app.posthog.com' });

  const BindUserPurchase = API.service('shop/bind_user_purchase/');
  export let organization;
  export let product;
  export let user;
  export let matchkey;
  export let location;
  let loading = false;

  const referenceLabels = {
    Health: 'Doctor',
    Gym: 'Coach',
    'Tactical & First Responders': "Director"
  }

  const urlParams = new URL(document.location).searchParams;
  const inviteKey = urlParams.get("inviteKey");

  let showCustomerInfo = true;
  let bindingUserPromise;
  let paymentIntentData;
  let showPriceDetails = false;
  let completeResearchOrder = false;
  let error, response;
  let error_message = '';

  organization = JSON.parse(organization);
  product = JSON.parse(product);
  user = JSON.parse(user);
  matchkey = JSON.parse(matchkey);
  location = JSON.parse(location);

  let productInfo;

  const accentColor = tinycolor(organization.branding_primary_color);
  const overColor = tinycolor(organization.branding_primary_color);
  const overSecondaryColor = tinycolor(organization.branding_secondary_color);
  const isDark = tinycolor(organization.branding_primary_color).isDark();
  function getFamilyLogo() {
    if (organization.is_fertility_org) {
      return isDark ? otoClinicLight : otoClinicBlack;
    }
    if (organization.type.toLowerCase() === 'tactical & first responders') {
      return isDark ? otoTacticalLight : otoTacticalBlack;
    }
    if (organization.type.toLowerCase() === 'gym') {
      return isDark ? otoGymLight : otoGymBlack;
    }
    return isDark ? otoFamilyWhite : otoFamilyGray;
  }
  let familyLogo = getFamilyLogo();

  let styles = {
    'primary-color': organization.branding_primary_color,
    'secondary-color': organization.branding_secondary_color,
    'accent-color': accentColor.isLight() ? accentColor.darken(20).toHexString() : accentColor.lighten(20).toHexString(),
    'over-primary-color': overColor.isLight() ? overColor.darken(100).toHexString() : overColor.lighten(100).toHexString(),
    'over-secondary-color': overSecondaryColor.isLight() ? overSecondaryColor.darken(100).toHexString() : overSecondaryColor.lighten(100).toHexString()
  };

  $: cssVarStyles = Object.entries(styles)
          .map(([key, value]) => `--${key}:${value}`)
          .join(';');

  API.host(organization.api);

  let customerData = {
    firstname:user?.firstname || '',
    lastname:user?.lastname || '',
    email:user?.email || '',
    country:user?.countrycode || '',
    phonenumber: user?.phone || ''
  }

  let shopData = writable({
    price: null,
    serviceProvider: matchkey.service_provider?.guid || '',
    location: location.guid, // we should always have a location, cause this is an invite
    productType: 'single', // because this is an invite, we can default to single...
    pick_up_location: forcesLocalPickup(location, organization) ? "Pick up at location" : "Mail to me"
  });

  if(organization && window.posthog){
    posthog.register({
        'organization': organization.nme,
        'product':product.nme
    })
  }
  posthog.capture('store-entry', { value: true });

  setContext("SHOP",{
    org:organization,
    product,
    user,
    shopData,
    location:writable(location),
    matchkey,
    inviteKey
  });

  onMount(() => {
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if(clientSecret) {
      paymentIntentData = {
        completed:true,
        client_secret:clientSecret
      }
    }
  });

  function purchaseComplete(e){
    bindingUserPromise = bindUser(e);
    showCustomerInfo = false;
  }

  async function bindUser({detail}) {
    loading = true;
    let {subscription, paymentIntent} = detail;

    let data = {
      org: organization.guid,
      subscription: subscription,
      purchase: paymentIntent,
      product: product,
      invite_key: inviteKey,
      location: location.guid
    }

    if($shopData.price.guid) {
      data.tier = $shopData.price.guid
    }

    if(!$shopData.remove_belt){
      let belts = $shopData.beltSizes.map(b => {
        return {qty:1, sku:b}
      });
      data = {
        ...data,
        ...{
          pickup_location:$shopData.pick_up_location,
          equipment: shopData.remove_belt ? [] : [{qty:($shopData.productType === 'couple' ? 2 : 1),sku:'electrodes-50'},...belts]
        }
      }
    }

    [error, response] = await to(BindUserPurchase.post(data));
    loading = false;
    if (response) {
      window.posthog.capture('store-purchase-complete', {value: true});
      //window.Marketing.addTagsToUser({active_lead: false, active_customer:true});
    } else {
      error_message = "There was an error completing your purchase. Please contact OTO support at support@oto.coach";
    }
  }

  function back() {
    showCustomerInfo = true;
    bindingUserPromise = null;
  }

  function onPriceUpdated({detail}) {
    if(productInfo){
      showPriceDetails = true;
      productInfo.updatePrice(detail)
    }
  }

</script>

<style type="text/scss" global>

  .store-wrapper:before {
    @media screen and (min-width:1201px){
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      background: #ffffff;
      content: " ";
      height: 100%;
      position: fixed;
      right: 0;
      top: 0;
      -webkit-transform-origin: right;
      -ms-transform-origin: right;
      transform-origin: right;
      width: 50%;
    }

  }
  .store-wrapper:before {
    @media screen and (min-width:1201px){
      box-shadow: 15px 0 30px 0 rgba(0,0,0,.18);
    }
  }

  .org-bg {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: -1;
  }

  .oto-image {
    bottom: 30px;
    img {
      width:100%;
    }

    @media screen and (min-width:1200px){
      margin-top: auto;
      position: fixed;
      width: 245px;
      left: calc(100% / 2 - calc(100% / 3));
    }

    @media screen and (max-width:1200px){
      width: 245px;
    }
  }

  .tfc-flow {
    .product-info.tfc-prod {
      @media screen and (max-width:1200px){
        @apply w-11/12;
        .logo {
          @apply mt-4;
          img {
            @apply max-h-12;
          }
        }
        .welcome {
          @apply text-center;
          span {
            @apply block;
          }
        }
        .activate-text {
          @apply hidden;
        }
      }
    }
    .app-wrapper {
      @media screen and (max-width:1200px){
        @apply static;
      }
    }
  }

  .org-name {
    .logo {
      max-width:300px;
    }
  }

  .purchase-success {
    @apply mx-auto w-['300px'] flex flex-col text-center;
  }

  .subscription-invite .tfc-onboarding .product-info{
    display:none
  }
  .subscription-invite .tfc-onboarding .customer-info{
    width:100%

  }

  :global(.subscription-invite .customer-info){
    @media screen and (min-height:1000px){
      justify-content: center;
      height:100%;
    }
  }

</style>
<Tailwind/>
<div class="store-wrapper subscription-invite absolute top-0 left-0 w-full h-full flex items-center justify-center" class:dark={isDark} class:light={!isDark} style="{cssVarStyles}">
  <div class="org-bg" style="background-color:{organization.branding_primary_color}"></div>
  <div class="app-wrapper tfc-flow overflow-auto">
    <div class="product-info tfc-prod text-over-primary" class:purchase-step={showPriceDetails}>
      <div class="org-name flex items-center gap-2 mb-3">
        <div class="logo">
          <img class="inline-block rounded-md"src="{organization.branding_logo}" alt="">
        </div>
      </div>
      <p class="welcome lg:max-w-[300px] px-2.5 py-1 lg:px-0"><span>Welcome {user.firstname || ''}.</span> You've been invited {#if matchkey.service_provider}by {matchkey.service_provider.firstname} {matchkey.service_provider.lastname}{:else}to join {organization.nme}{/if}.</p>
      <p class="activate-text lg:max-w-[300px] px-2.5 py-1 mb-4 lg:px-0">Please fill your account information to activate your subscription.</p>
    </div>


    <div class="customer-info bg-white px-5 pt-6">
        {#if matchkey.is_disabled}
          <p class="mt-10 text-center">Invitation has already been used!</p>
        {:else if loading}
          <div class="purchase-success mt-20 lg:mt-0">
            <i class="fa-duotone text-5xl fa-truck-ramp-box"></i>
            <span class="text-xl mt-3">
                Please wait... We are processing your order.
              </span>
            <p class="mt-3 text-gray-400 text-base text-center">This may take a minute.</p>
          </div>
          {:else }
            {#if !$shopData.productType}
              <ChooseProduct hidewrapper={true}/>
            {:else}
              {#if !matchkey.researchInvite && !$shopData.price}
                <ChoosePricing showBack={!matchkey} showBranding={false}/>
              {:else if showCustomerInfo}
                <CustomerInformation on:updatePrice={onPriceUpdated} on:completeSkipBind={e =>{showCustomerInfo = false; completeResearchOrder=true}} on:back={e=>{$shopData.price = null}} showBackOnOne={!matchkey.researchInvite} {customerData} on:complete={purchaseComplete} />
              {:else if response}
                <div class="purchase-success">
                  <i class="fa-duotone text-5xl fa-badge-check" style="color: green;"></i>
                  <span class="text-xl mt-3">
                    Thank you for your purchase!
                  </span>
                  <p class="mt-3 text-gray-400 text-base text-center">An email has been sent with further instructions on activating your account.</p>
                </div>
              {:else if error_message}
                <div class="w-full text-left my-20">
                  <button class="back" on:click={back}><i class="fa-sharp fa-solid fa-arrow-left mr-2"></i> Back </button>
                </div>
                <div class="bg-red-50 p-4 text-red-500 font-bold rounded-md">{error_message}</div>
              {/if}
            {/if}
          {/if}
        <!--{/if}-->
      {#if completeResearchOrder}
      <div class="purchase-success">
        <i class="fa-duotone text-5xl fa-badge-check" style="color: green;"></i>
        <span class="text-xl mt-3">You have successfully been enrolled! </span>
        <p class="mt-3 text-gray-400 text-base text-center">An email has been sent with further instructions on activating your account.</p>
      </div>
      {/if}
    </div>
    <MediaQuery query="(max-width: 1200px)" let:matches>
      {#if matches}
        <div class="oto-image py-4">
          <img src="{familyLogo}" alt="">
        </div>
      {/if}
    </MediaQuery>
  </div>

  <MediaQuery query="(min-width: 1200px)" let:matches>
  	{#if matches}
      <div class="oto-image">
        <img src="{familyLogo}" alt="">
      </div>
    {/if}
  </MediaQuery>

</div>
